import { isObject } from 'fela-utils';

function resolveNamedMediaQuery(style, mediaQueryMap) {
  for (var property in style) {
    var value = style[property];

    if (isObject(value)) {
      var resolvedValue = resolveNamedMediaQuery(value, mediaQueryMap);

      if (mediaQueryMap.hasOwnProperty(property)) {
        style[mediaQueryMap[property]] = resolvedValue;
        delete style[property];
      }
    }
  }

  return style;
}

export default function namedMediaQuery(mediaQueryMap) {
  return function (style) {
    return resolveNamedMediaQuery(style, mediaQueryMap);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-named-media-query/es/index.js
// module id = 168
// module chunks = 0